import React from 'react';

interface Props {
  lang?: string;
}
function Fonts({ lang }: Props) {
  return (
    <>
      <link
        id={'noto-sans'}
        href='https://fonts.googleapis.com/css2?family=Noto+Sans:wght@100..900&display=swap'
        rel='stylesheet'
      />
      {lang === 'ja' && (
        <link
          id={'noto-sans'}
          href='https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100..900&display=swap'
          rel='stylesheet'
        />
      )}
      {lang === 'th' && (
        <link
          id={'noto-sans'}
          href='https://fonts.googleapis.com/css2?family=Noto+Sans+Thai:wght@100..900&display=swap'
          rel='stylesheet'
        />
      )}
      {lang === 'zh-Hans' && (
        <link
          id={'noto-sans'}
          href='https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@100..900&display=swap'
          rel='stylesheet'
        />
      )}
    </>
  );
}

export default React.memo(Fonts);
